import Cleave from 'cleave.js';
import OnloadHandler from 'onload_handler';
import ClipboardJS from 'clipboard';
import { setupCountryCascade, setupCascade } from 'locations';

// Setup event delegation
window.$ = $;
import { delegate } from 'jquery-events-to-dom-events';
delegate('change');

const initBoostrap = function(){
  $('[data-toggle="tooltip"]').tooltip()
  $('[data-toggle="popover"]').popover()
  $('.toast').toast({ autohide: false })
  $('#toast').toast('show')  
}

const onlyIntegerChange = function(event) {
  if (
    (event.key.length > 1) ||
    (
      (event.key === "-") &&
      (event.currentTarget.value.length === 0)
    ) ||
    /\d/.test(event.key)
  ) return;
  event.preventDefault();
}

const initFields = function(){
  _.each($('.masked.date'), function(field){
    var cleave = new Cleave(field, {
        date: true,
        delimiter: '/',
        datePattern: ['d', 'm', 'Y']
    });
  })

  _.each($('.masked.phone'), function(field){
    new Cleave(field, {
        numericOnly: true,
        blocks: [3, 3, 40],
        delimiters: [" ", " ", " "]
    });
  })

  _.each($('.country-select'), function(el){
    setupCountryCascade(el);
  });
  _.each($('.province-select'), function(el){
    setupCascade(el)
  });

  _.each($('.only-integer'), function(el){
    $(el).
      prop('step', 1).
      prop('pattern', '/d+').
      on('keydown', onlyIntegerChange);
  });
}

const initClipboardCopy = function(){
  var clipboard = new ClipboardJS('.clipboard-btn');
  // Success
  clipboard.on('success', function(e) {
    alert('Copiato!');
  });
  // Error
  clipboard.on('error', function(e) {
    console.log('Error copying', e);
  });
}

OnloadHandler(function(){
  initBoostrap();
  initFields();
  initClipboardCopy();

  $(document).find(".trix-button-group--file-tools").remove();
  
  // /* remove the file upload from the default toolbar */
  // addEventListener("trix-initialize", function(event) {
  //   $(event.target.toolbarElement).find(".trix-button-group--file-tools").remove();
  // })
})
